<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <app-title>Sedes del Cliente</app-title>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                Seleccione la sede donde se va a realizar la ronda
            </v-flex>
        </v-layout>
        <v-layout v-for="venue in venues" :key="venue.id">
            <v-flex xs12>
                <v-btn color="primary" block @click="selectVenue(venue)">{{ venue.name }}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
    computed: {
        venues() {
            return this.client.venues;
        }
    },
    methods: {
        ...mapMutations({
            setVenue: 'venue'
        }),
        selectVenue(venue) {
            this.setVenue(venue);
            this.$router.push({ name: 'rounds' });
        }
    }
}
</script>
